/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:30:23
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 15:17:43
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API_URL } from '@/config';
import Card from '@/components/Common/Card';
import PagePaginationByLimitAndOffset from '@/components/Common/PagePaginationByLimitAndOffset';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PaymentsList',

  props: ['customerPayments', 'isLoading', 'acl'],

  components: { Card, PagePaginationByLimitAndOffset },

  data() {
    return {
      limit: 10,
      offset: 0,
      totalNumberOfPages: 0,
      page: 0,
    };
  },

  computed: {
    actualPage() {
      return this.page;
    },
    numberOfPages() {
      return this.totalNumberOfPages;
    },
    downloadPayments() {
      return `${API_URL}/payments/export`;
    },
  },

  methods: {
    pagesTotal(pages) {
      this.totalNumberOfPages = pages;
    },
    currentPage(page) {
      this.page = page;
    },
    nextPage(offset) {
      this.offset = offset;
    },
    prevPage(offset) {
      this.offset = offset;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/PaymentsAndInvoices/PaymentsList/component.js